import { render, staticRenderFns } from "./GenAiEventsModal.vue?vue&type=template&id=2a715d94&scoped=true&"
import script from "./GenAiEventsModal.vue?vue&type=script&lang=ts&"
export * from "./GenAiEventsModal.vue?vue&type=script&lang=ts&"
import style0 from "./GenAiEventsModal.vue?vue&type=style&index=0&id=2a715d94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a715d94",
  null
  
)

export default component.exports